import gql from 'graphql-tag';
import { Fragments } from '@shared/api/fragments';

export const event = gql`
  subscription CardEventSubscription {
    event: cardEvent {
      type
      cards {
        ...Card
      }
    }
  }

  ${Fragments.card.card}
`;
